import { render, staticRenderFns } from "./VehicleBreakdownApprove.vue?vue&type=template&id=1ee2ed68"
import script from "./VehicleBreakdownApprove.vue?vue&type=script&lang=js"
export * from "./VehicleBreakdownApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports